import { Leva } from "leva";
import ResizingCanvas from "../ResizingCanvas";
import PlaneMesh from "./PlaneMesh";
import s from "./style.module.css";

const WaveSection = () => {
  return (
    <section id="wave_section" className="section">
      {/* Debugger controller */}
      <Leva />
      <div className={s.cc}>
        <h1>Wave Plane</h1>
        <p>Please scroll down!</p>
        <a href="https://github.com/thisyujeong">@thisyujeong</a>
      </div>
      <div className={s.title_box}>
        <h2 className={s.title}>
          <span>Neque</span>
          <span>Standard</span>
        </h2>
      </div>
      <ResizingCanvas id={s.wave_canvas}>
        <PlaneMesh />
      </ResizingCanvas>
    </section>
  );
};

export default WaveSection;
